import React, { useState } from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useAppDispatch } from "../../../utils/hooks";
import { AppColor, ModerationReportViewMode } from '../../../types/Constants';
import { setReportViewType } from "../../../redux/actions";

const QueuedReportListAction: React.FC = () => {

  const dispatch = useAppDispatch();
  const [viewMode, setViewMode] = useState<string>(ModerationReportViewMode.Queue);

  const handleViewModeChange = (newValue: string) => {
    dispatch(setReportViewType(newValue));
    setViewMode(newValue);
  };

  return (
    <>
      <ToggleButtonGroup
        exclusive
        value={viewMode}
        onChange={(event, newValue) => {
          if (newValue) handleViewModeChange(newValue);
        }}
        aria-label="ReportType"
        sx={{
          flexWrap: "nowrap",
          "& .MuiToggleButton-root": {
            textTransform: "none",
            padding: "2px",
            minWidth: "106px",
          },
          "& .Mui-selected": {
            color: AppColor.baseOrange,
            backgroundColor: AppColor.orangeBackground
          }
        }}>
        <ToggleButton
          tabIndex={0}
          value={ModerationReportViewMode.Queue}>
          Queue
        </ToggleButton>
        <ToggleButton
          tabIndex={1}
          value={ModerationReportViewMode.History}>
          History
        </ToggleButton>
      </ToggleButtonGroup>
    </>
  );
};

export default QueuedReportListAction;
